import { Grid, Slide, Typography } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'

import { TrackButton } from 'artkive/components/Tracker'
import { BREAKPOINTS } from 'artkive/utils/constants'

export const ContainerSlide = styled(Slide)(({ theme }) => ({
  boxShadow: theme.customShadows[3],
  zIndex: 1000,
}))

export const BoxWrap = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: `${theme.constants.toolbar.height}px`,
  left: 0,
  width: '100%',
  zIndex: 100,
  overflow: 'hidden',
}))

export const LeftPartGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.colors.sky[100],
  padding: '32px 8px',
  [theme.breakpoints.up(BREAKPOINTS.md)]: {
    flexGrow: 0,
    maxWidth: '61%',
    flexBasis: '61%',
  },
  [theme.breakpoints.up(BREAKPOINTS.lg)]: {
    padding: '24px 16px',
  },
  [theme.breakpoints.up(1360)]: {
    padding: '32px 24px 24px',
  },
  [theme.breakpoints.up(BREAKPOINTS.xl)]: {
    padding: '48px 24px 24px',
  },
  [theme.breakpoints.up(BREAKPOINTS.xxl)]: {
    padding: '48px 60px 24px',
  },
}))

export const RightPartGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.colors.sky[300],
  position: 'relative',
  [theme.breakpoints.up(BREAKPOINTS.md)]: {
    flexGrow: 0,
    maxWidth: '39%',
    flexBasis: '39%',
  },
}))

export const Card = styled(TrackButton)(({ theme }) => ({
  backgroundColor: 'transparent',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  gap: '16px',
  padding: '16px',
  margin: '0 10px',
  '&:hover': {
    textTransform: 'none',
    textDecoration: 'underline',
    textDecorationColor: theme.colors.blue[900],
    '& img': {
      boxShadow: theme.customShadows[6],
    },
  },
  [theme.breakpoints.up(BREAKPOINTS.lg)]: {
    gap: '24px',
    padding: '24px',
  },
  [theme.breakpoints.up(BREAKPOINTS.xxl)]: {
    padding: '24px 24px',
  },
}))

export const RightPartContentBox = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'center',
  [theme.breakpoints.up(BREAKPOINTS.xl)]: {
    padding: '20px 28px 0',
  },
  [theme.breakpoints.up(BREAKPOINTS.xxl)]: {
    padding: '20px 70px 0',
  },
}))

export const RightPartTitle = styled(Typography)(({ theme }) => ({
  color: theme.colors.grey[900],
  fontSize: '1rem',
  fontWeight: 600,
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',

  position: 'absolute',
  top: '12px',
  padding: '0 24px',

  '&::before, &::after': {
    content: '""',
    flex: 1,
    borderBottom: `1px solid ${theme.colors.sky[500]}`,
  },
  '&::before': {
    marginRight: '16px',
  },
  '&::after': {
    marginLeft: '16px',
  },
  [theme.breakpoints.up(1360)]: {
    fontSize: '1.125rem',
  },
  [theme.breakpoints.up(1440)]: {
    padding: '0 32px',
  },
  [theme.breakpoints.up(BREAKPOINTS.xl)]: {
    fontSize: '1.25rem',
    top: '20px',
    padding: '0 40px',
  },
  [theme.breakpoints.up(BREAKPOINTS.xxl)]: {
    padding: '0 84px',
  },
}))

export const ProductImage = styled('img')(({ theme }) => ({
  objectFit: 'cover',
  height: '128px',
  width: '100%',
  [theme.breakpoints.up(1080)]: {
    height: '144px',
  },
  [theme.breakpoints.up(BREAKPOINTS.lg)]: {
    height: '158px',
    width: '230px',
  },
  [theme.breakpoints.up(1440)]: {
    height: '200px',
    width: '290px',
  },
  [theme.breakpoints.up(BREAKPOINTS.xxl)]: {
    height: '220px',
    width: '320px',
  },
}))

export const OtherProductImage = styled('img')(({ theme }) => ({
  width: '128px',
  height: '128px',
  [theme.breakpoints.up(1080)]: {
    width: '144px',
    height: '144px',
  },
  [theme.breakpoints.up(BREAKPOINTS.lg)]: {
    width: '158px',
    height: '158px',
  },
  [theme.breakpoints.up(1440)]: {
    height: '200px',
    width: '200px',
  },
  [theme.breakpoints.up(BREAKPOINTS.xxl)]: {
    height: '220px',
    width: '220px',
  },
}))
